import React, { useState, useEffect, forwardRef } from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import { hasAccess, mapRowId } from "../../common/commonFunctions";
import RatesGrid from "./Grid";
import Snackbar from "@mui/material/Snackbar";
import { constants, EndPoint, messages } from "../../common/constants";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import _ from "lodash";
import axios from "axios";
import moment from "moment";
import { Column } from "ag-grid-community";
import { ToastContainer, toast } from "react-toastify";
import SpinnerFullScreen from "../../components/SpinnerFullScreen";
import { exportMultipleSheetsAsExcel } from "ag-grid-enterprise";
import { serviceAPIMapping } from "../../config/service-api-mapping";
import { pageConstant } from "../../config/pageConstant";
import { Card, CardContent } from "@mui/material";
import excel from "../../assets/images/excel.svg";
import { validateRate } from "../../common/tradeValidations";
import { isServiceHealthy } from "../../utils/API";

const RatesDashboard = () => {
  const [refData, setRefData] = useState<any>(null);
  const [gridApiSec, setGridApiSec] = useState<any>(null);
  const [snackbarMessage, setSnackbarMessage] = useState<any>("");
  const [open, setOpen] = useState(false);
  const [heightAG_1, setHeight] = useState(90);
  const [rows, setRows] = useState<Array<any>>([]);
  const [lastUpdatedDate, setLastUpdatedDate] = useState(
    moment(new Date()).format("MM/DD/yyyy HH:mm")
  );
  const [doShowFullScreenLoader, setDoShowFullScreenLoader] =
    useState<boolean>(false);
  const [isDuplicateTicker, setIsDuplicateTicker] = useState<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(true);
  const [isSaveDisabled, setIsSaveDisabled] =  useState<boolean>(true)
  const [isCancelDisabled, setIsCancelDisabled] = useState<boolean>(true)
   const [isAddDisabled, setIsAddDisabled] =  useState<boolean>(false)

  const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const getRatesInfo = async () => {
    setIsSaveDisabled(true)
    setIsCancelDisabled(true)
    setIsAddDisabled(false)
    const token = window.localStorage.getItem("refreshtoken");
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      // setDoShowFullScreenLoader(true);
      // setRows([]);
      let activeAccountCode = window.localStorage.getItem("activeAccountCode");
      axios
        .post(
          `${serviceAPIMapping["RATEMANAGEMENT-SERVICE"].apiRouteURL}${EndPoint.getRateDetails}?account_id=` +
            activeAccountCode,
          {},
          {
            headers: headers,
          }
        )
        .then((response: any) => {
          if (!response) {
            setOpen(true);
            setSnackbarMessage(messages.TickerDownMessage);
          } else if (!_.isUndefined(response) && response?.status === 200) {
            const rowData: any = response?.data;
            const mappedRows = mapRowId(rowData);
            setLastUpdatedDate(moment(new Date()).format("MM/DD/yyyy HH:mm"));
            setRows(mappedRows);
          } else if (response?.status === 401) {
            /// TODO: implement proper logout
            //navigate('/signin')
          }
        });
    } catch (err) {
      setRows([]);
    } finally {
      setTimeout(() => {
        setDoShowFullScreenLoader(false);
      }, 300);
    }
  };

  const refreshGrid = () => {
    getRatesInfo();
  };

  const onRefreshGrid = ()=>{
    setRows([])
    setIsDuplicateTicker(false);
    refreshGrid()
    setIsSaveDisabled(true)
    setIsCancelDisabled(true)
    setIsAddDisabled(false)
  }

  useEffect(() => {
    getServiceHealthCheck()
    setHeight(86);
  }, []);

  const onFilterTextChange = _.debounce((e: any) => {
    gridApiSec?.setQuickFilter(e.target.value);
  }, 800);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === constants.clickaway) {
      return;
    }

    setOpen(false);
  };

const onAddEvent = () => {
  const now = moment(new Date()).format("YYYY-MM-DD HH:mm"); 
  const date =  moment(new Date()).format("YYYY-MM-DD"); 
  setRows((previousRows: any) => {
    const obj = {
      avail_date: date,
      cusip: "",
      isin: "",
      ticker: "",
      name: "",
      qty: "",
      lp_date: date,
      lp_rate_out: "",
      lp_rate_new: "",
      lp_last_avg: "",
      lp_last_min: "",
      lp_last_max: "",
      lp_out_shares: "",
      lp_new_shares: "",
      sss_mb_borr_rate: "",
      sss_mb_loan_rate: "",
      sss_max_ln_rate: "",
      sss_min_ln_rate: "",
      max_rate_lender: "",
      min_rate_lender: "",
      ss_ln_rate: "",
      ss_br_rate: "",
      spread: "",
      ss_locate_rate: "",
      cents_spread: "0",
      price_date: date,
      price_market: "",
      cents_share: "",
      current_timestamp: now,
      hasError: false,
      isNewRowInsert: "true",
      id: previousRows?.length + 1,
      isTickerUpdated: false,
      isSpreadUpdated: false,
      isCentsSpreadUpdated: false,
      isBorrowRateUpdated: false,
      isLoanRateUpdated: false,
      isLocateRateUpdated: false,
      isCentsPerShareUpdated: false,
    };
    return [obj, ...previousRows];
  });
  setIsSaveDisabled(false);
  setIsCancelDisabled(false);
  setIsAddDisabled(true);
};


  const onSave = () => {
    const insertRows = [...rows]?.filter((x: any) => x.isNewRowInsert);
    const updateRows = [...rows]?.filter((x: any) => x.isRowUpdated);

    // if (_.isArray(insertRows) && insertRows?.length > 0) {
    //   const validRows = insertRows?.filter((row: any) => isValidRateRow(row));

    //   if (_.isArray(validRows) && validRows?.length > 0) {
    //     insertRates(validRows);
    //   }
    // }

    // if (_.isArray(updateRows) && updateRows?.length > 0) {
    //   const validRows = updateRows?.filter((row: any) => isValidRateRow(row));
    //   if (_.isArray(validRows) && validRows?.length > 0) {
    //     updateRates(validRows);
    //   }
    // }

    const validInsertRows = insertRows?.filter((row: any) => isValidRateRow(row));
    const validUpdateRows = updateRows?.filter((row: any) => isValidRateRow(row));

    if ((!validInsertRows?.length) && (!validUpdateRows?.length)) {
      toast.error("No valid rows to save. Please correct the errors.");
      return;
    }

    if (validInsertRows?.length > 0) {
      insertRates(validInsertRows);
    }

    if (validUpdateRows?.length > 0) {
      updateRates(validUpdateRows);
    }

  };

  const insertRates = (rows: any) => {
    try {
      setDoShowFullScreenLoader(true);
      const request = rows;
      let accountId = window.localStorage.getItem("activeAccountCode");
      const token = window.localStorage.getItem("refreshtoken");
      const header = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      axios
        .post(
          `${serviceAPIMapping["RATEMANAGEMENT-SERVICE"].apiRouteURL}${EndPoint.saveRateDetailsList}?account_id=${accountId}`,
          JSON.stringify(request),
          {
            headers: header,
          }
        )
        .then((response: any) => {
          if (!response) {
            setOpen(true);
            setSnackbarMessage(messages.TickerDownMessage);
          } else if (!_.isUndefined(response) && response?.status === 200) {
            toast.success("Rates saved successfully");
            getRatesInfo();
          } else if (response?.status === 401) {
            /// TODO: implement proper logout
            //navigate('/signin')
          }
        });
    } catch (err) {
      toast.error("Failed to save rates");
      //setApiExceptionHandler({ isError: true, error: err })
    } finally {
      setDoShowFullScreenLoader(false);
    }
  };

  const updateRates = (rows: any) => {
    try {
      setDoShowFullScreenLoader(true);
      let accountId = window.localStorage.getItem("activeAccountCode");
      const request = rows;
      const token = window.localStorage.getItem("refreshtoken");
      const header = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      axios
        .post(
          `${serviceAPIMapping["RATEMANAGEMENT-SERVICE"].apiRouteURL}${EndPoint.updateRateDetailsList}?account_id=${accountId}`,
          JSON.stringify(request),
          {
            headers: header,
          }
        )
        .then((response: any) => {
          if (!response) {
            setOpen(true);
            setSnackbarMessage(messages.TickerDownMessage);
          } else if (!_.isUndefined(response) && response?.status === 200) {
            getRatesInfo();
            toast.success("Rates saved successfully");
          } else if (response?.status === 401) {
            /// TODO: implement proper logout
            //navigate('/signin')
          }
        });
    } catch (err) {
      toast.error("Failed to save rates");
    } finally {
      setDoShowFullScreenLoader(false);
    }
  };

  const isValidRateRow = (row: any) => {
    const isValid =
      row?.ticker &&
      !_.isEmpty(row?.ticker) &&
      row?.spread &&
      !_.isNaN(row?.spread) &&
      row?.cents_spread &&
      !_.isNaN(row?.cents_spread) &&
      row?.ss_br_rate &&
      !_.isNaN(row?.ss_br_rate) &&
      row?.ss_ln_rate &&
      !_.isNaN(row?.ss_ln_rate) &&
      row?.ss_locate_rate &&
      !_.isNaN(row?.ss_locate_rate) &&
      row?.cents_share &&
      !_.isNaN(row?.cents_share);

    return isValid === true;
  };

  const isValidNumberInput = (value: any) => {
    return !isNaN(value) && /^\d+(\.\d+)?$/.test(value);
  };

  const onCellChange = async (row: any, changeValue: any, column: Column) => {
    row.isRowUpdated = !row?.isNewRowInsert;
    row.updatedColumn = column.getColId();
    if(row.isRowUpdated){
       setIsAddDisabled(true)
      setIsSaveDisabled(false)
      setIsCancelDisabled(false)
    }
    if (column.getColId() === "ticker") {
      row.isTickerUpdated = true;
      if (changeValue && !_.isEmpty(changeValue)) {
        let accountId = window.localStorage.getItem("activeAccountCode");
        const request = {
          function_code: "fn_rpt_sl_quote_ticker_cusip",
          function_param: {
            ticker_in: changeValue,
            accountid: accountId,
            cusip_in:null
          },
        };
        const token = window.localStorage.getItem("refreshtoken");
        const header = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        };

        try {
          await axios
            .post(
              `${serviceAPIMapping["REPORTING-SERVICE"].apiRouteURL}${EndPoint.reportFn}`,
              request,
              { headers: header }
            )
            .then(async (kpiResponse: any) => {
              if (kpiResponse?.status === 200) {
                const kpiJson = await kpiResponse?.data;
                if (kpiJson && _.isArray(kpiJson) && kpiJson?.length > 0) {
                  row.cusip = kpiJson[0]?.cusip;
                  row.price_market = kpiJson[0]?.price;
                  row.name = kpiJson[0]?.name;
                  row.lp_rate_out = !_.isEmpty(kpiJson[0]?.lp_rate_out)
                    ? kpiJson[0]?.lp_rate_out?.toFixed(3)
                    : kpiJson[0]?.lp_rate_out;
                  row.lp_rate_new = !_.isEmpty(kpiJson[0]?.lp_rate_new)
                    ? kpiJson[0]?.lp_rate_new?.toFixed(3)
                    : kpiJson[0]?.lp_rate_new;
                  row.lp_last_avg = !_.isEmpty(kpiJson[0]?.lp_rate_last)
                    ? kpiJson[0]?.lp_rate_last?.toFixed(3)
                    : kpiJson[0]?.lp_rate_last;
                  row.isin = kpiJson[0]?.isin;
                  row.spread = kpiJson[0]?.spread;
                  row.ss_br_rate = !_.isEmpty(kpiJson[0]?.ss_br_rate)
                    ? kpiJson[0]?.ss_br_rate?.toFixed(3)
                    : kpiJson[0]?.ss_br_rate;
                  row.ss_ln_rate = !_.isEmpty(kpiJson[0]?.ss_ln_rate)
                    ? kpiJson[0]?.ss_ln_rate?.toFixed(3)
                    : kpiJson[0]?.ss_ln_rate;
                  row.ss_locate_rate = !_.isEmpty(kpiJson[0]?.ss_locate_rate)
                    ? kpiJson[0]?.ss_locate_rate?.toFixed(3)
                    : kpiJson[0]?.ss_locate_rate;
                  row.cents_share = !_.isEmpty(kpiJson[0]?.cents_share)
                    ? kpiJson[0]?.cents_share?.toFixed(3)
                    : kpiJson[0]?.cents_share;
                  setRows((previousRows: any) => {
                    const newRows = [...previousRows];
                    const ind = newRows?.findIndex(
                      (x: any) => x?.id === row?.id
                    );
                    if (ind >= 0) {
                      newRows[ind] = row;
                    }
                    const ticker = [...previousRows]?.filter(
                      (x: any) =>
                        x?.ticker?.toUpperCase() ===
                          row?.ticker?.toUpperCase() ||
                        x?.cusip?.toUpperCase() === row?.cusip?.toUpperCase()
                    );
                    const isDuplicate = ticker?.length >= 2;
                    setIsDuplicateTicker(isDuplicate);
                    if (isDuplicate) {
                      toast?.error("Duplicate Ticker or Cusip are not allowed");
                    }
                    return newRows;
                  });
                } else {
                  if (kpiJson && _.isArray(kpiJson) && _.isEmpty(kpiJson)) {
                    setIsDuplicateTicker(true);
                    toast?.error("Ticker is not valid");
                    row.cusip = null;
                    row.price_market = null;
                    row.name = null;
                    row.lp_rate_out = null;
                    row.lp_rate_new = null;
                    row.lp_last_avg = null;
                    row.isin = null;
                    row.spread = null;
                    row.ss_br_rate = null;
                    row.ss_ln_rate = null;
                    row.ss_locate_rate = null;
                    row.cents_share = null;
                    row.cents_spread = null;
                    setRows((previousRows: any) => {
                      const newRows = [...previousRows];
                      const ind = newRows?.findIndex(
                        (x: any) => x?.id === row?.id
                      );
                      if (ind >= 0) {
                        newRows[ind] = row;
                      }
                      return newRows;
                    });
                  }
                }
              } else if (kpiResponse?.status === 401) {
                // logout(channel)
              } else {
                setIsDuplicateTicker(true);
                toast?.error("Ticker is not valid");
              }
            });
        } catch (err) {
          console.log("error", err);
        }
      } else {
        row.cusip = null;
        row.price_market = null;
        row.name = null;
        row.lp_rate_out = null;
        row.lp_rate_new = null;
        row.lp_last_avg = null;
        row.isin = null;
        row.spread = null;
        row.ss_br_rate = null;
        row.ss_ln_rate = null;
        row.ss_locate_rate = null;
        row.cents_share = null;
        row.cents_spread = null;
        setRows((previousRows: any) => {
          const newRows = [...previousRows];
          const ind = newRows?.findIndex((x: any) => x?.id === row?.id);
          if (ind >= 0) {
            newRows[ind] = row;
          }
          return newRows;
        });
      }
    } else {
      switch (column.getColId()) {
        case "ticker":
          row.isTickerUpdated = true;
          break;
        case "spread":
          row.isSpreadUpdated = true;
          row.hasError = !isValidNumberInput(changeValue)
          break;
        case "cents_spread":
          row.hasError = !isValidNumberInput(changeValue)
          row.isCentsSpreadUpdated = true;
          break;
        case "ss_br_rate":
          row.isBorrowRateUpdated = true;
          row.hasError = !validateRate(changeValue)
          break;
        case "ss_ln_rate":
          row.isLoanRateUpdated = true;
          row.hasError = !validateRate(changeValue)
          break;
        case "ss_locate_rate":
          row.isLocateRateUpdated = true;
          row.hasError = !validateRate(changeValue)
          break;
        case "cents_share":
          row.isCentsPerShareUpdated = true;
          row.hasError = !isValidNumberInput(changeValue)
          break;
      }

      if(isNaN(changeValue) || isNaN(row?.spread) 
        || isNaN(row?.cents_spread) || isNaN(row?.ss_br_rate) || isNaN(row?.ss_ln_rate) 
      || isNaN(row?.ss_locate_rate)|| isNaN(row?.cents_share)){
        row.hasError = true
        
      }
      setRows((previousRows: any) => {
        const newRows = [...previousRows];
        const ind = newRows?.findIndex((x: any) => x?.id === row?.id);
        if (ind >= 0) {
          newRows[ind] = row;
        }

        let errors = newRows?.filter((val:any)=> val?.hasError)
        setHasError(errors?.length>0)

        return newRows;
      });
    }
  };

  function onExcelExport() {
    var spreadsheets = [];
    spreadsheets.push(
      refData?.current?.api?.getSheetDataForExcel?.({
        sheetName: "Rates Dashboard",
      })!
    );

    exportMultipleSheetsAsExcel({
      data: spreadsheets,
      fileName: "rates-dashboard.xlsx",
    });
  }

  const getCardHeight = () => {
    const offsetHeight = document?.getElementById("rates-title")?.offsetHeight;
    const divHeight = _.isUndefined(offsetHeight) ? 22 : offsetHeight + 12;

    return "calc(100% - " + divHeight + "px)";
  };

  //  useEffect(()=>{
  //       const returnInterval = setInterval(() => {
  //         refreshGrid();
  //       }, 15000);
  //       return () => clearInterval(returnInterval);
  //     },[])

 const getServiceHealthCheck = async () => {
    await isServiceHealthy(
      `${serviceAPIMapping["RATEMANAGEMENT-SERVICE"].apiRouteURL}/${EndPoint.actuator}`
    ).then((response: any) => {
      if (!response?.ok || response?.status === 503) {
        setSnackbarMessage(`Rate Management ${messages.serviceDownMessage}`);
        setOpen(true);
      } else {
        refreshGrid();
      }
    });
  };


  return (
    <>
      <Snackbar open={open} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="error"
          sx={{
            width: "100%",
            backgroundColor: "orange",
            textDecorationColor: "white",
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {doShowFullScreenLoader && <SpinnerFullScreen />}
      <div className="ps-3 mt-1" id="rates-title">
        Rates Dashboard
      </div>
      <Card style={{ height: getCardHeight() }} className="m-1">
        <CardContent className="h-100 w-100  px-2 pt-1 pb-2">
          <div className="minimizeIconforLoan">
            <div
              className="globalfiltermaindivSec mb-1"
              style={{ marginLeft: "0.3rem", marginTop: "0.2rem" }}
            >
              <input
                type="search"
                placeholder="Global search..."
                id="filter-text-box-sec"
                onInput={onFilterTextChange}
              />
              <SearchIcon style={{ fontSize: "1rem", color: "#1e355e" }} />
            </div>
            <div className="d-flex align-items-center">
              <div className="col d-flex justify-content-end align-items-center">
                <button
                  type="button"
                  onClick={onAddEvent}
                  className={
                    "metrics-btn p-2 h-65 d-flex align-items-center btn btn-primary me-1"
                  }
                  style={{ height: "1.5rem" }}
                  disabled={isAddDisabled ||
                    !hasAccess([
                      `${pageConstant.RATES_DASHBOARD}_RW`,
                      `${pageConstant.RATES_DASHBOARD}_ADMIN`,
                    ])
                  }
                >
                  Add
                </button>

                <button
                  type="button"
                  className={
                    "metrics-btn p-2 d-flex align-items-center btn btn-primary"
                  }
                  disabled={
                    isDuplicateTicker || hasError || isSaveDisabled ||
                    !hasAccess([
                      `${pageConstant.RATES_DASHBOARD}_RW`,
                      `${pageConstant.RATES_DASHBOARD}_ADMIN`,
                    ])
                  }
                  onClick={onSave}
                  style={{ height: "1.5rem" }}
                >
                  Save
                </button>

                <button
                  type="button"
                  className={
                    "metrics-btn p-2 d-flex align-items-center btn btn-primary ms-1 me-1"
                  }
                  onClick={onRefreshGrid}
                  style={{ height: "1.5rem" }}
                  disabled={
                   isCancelDisabled || !hasAccess([
                      `${pageConstant.RATES_DASHBOARD}_RW`,
                      `${pageConstant.RATES_DASHBOARD}_ADMIN`,
                    ])
                  }
                >
                  Cancel
                </button>
              </div>
              <span
                className="borrowExceldnld float-start"
                onClick={onExcelExport}
                title="Download Excel"
              >
                <img
                  src={excel}
                  alt=""
                  style={{
                    height: "1.8rem",
                    width: "1.8rem",
                    cursor: "pointer",
                  }}
                />
              </span>
              <div
                className="d-flex justify-content-end align-items-center cursor-pointer ms-0 pl-0"
                onClick={onRefreshGrid}
                title="Refresh Data"
              >
                <RefreshIcon
                  style={{
                    cursor: "pointer",
                    marginRight: "0.5rem",
                    color: "#1E355E",
                  }}
                />
                <div className="refreshsettimedateContract">
                  <div>Last updated on: </div>
                  <div>{lastUpdatedDate}</div>
                </div>
              </div>
            </div>
          </div>
          <div id="rates-dashboard" className="h-100 pb-2">
            <RatesGrid
              rowData={rows}
              height={heightAG_1}
              type="Rates Dashboard"
              getBtnRef={(gridRef: any) => {
                setRefData(gridRef);
              }}
              getGridApi={(gridApi: any) => {
                setGridApiSec(gridApi);
              }}
              onCellChange={(data: any, value: any, column: Column) => {
                onCellChange(data, value, column);
              }}
            />
          </div>
          <ToastContainer />
        </CardContent>
      </Card>
    </>
  );
};

export default RatesDashboard;
